module.exports = __webpack_public_path__ + "static/media/splash.b3ce220a.jpg";